import * as React from "react";
import {Form} from "semantic-ui-react";

interface IProps {
    id: string;
    value: string;
    apiRequest: Promise<{}>;
    onSelected: (event: any) => void;
    readOnly?: boolean | false;
    fluid?: boolean | false;
}

interface IState {
    options: IOptionItem[];
    defaultOptionValue: string;
    isFetchingData: boolean;
}

interface IOptionItem {
    key: string;
    text: string;
    value: string;
}

export class SelectOption extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            options: [{
                key: '0',
                value: '0',
                text: 'Loading Data...'
            }],
            defaultOptionValue: "Loading Data...",
            isFetchingData: true
        }
    }

    public componentDidMount = () => {

        this.props.apiRequest
            .then((data: any) => {
                if (data.isSuccess) {
                    this.setState({
                        isFetchingData: false,
                        options: data.result,
                        defaultOptionValue: "Pilih Opsi..."
                    });
                }
            });
    };

    public refresh = (apiRequest?: Promise<{}>) => {

        this.setState({
            options: [{
                key: '0',
                value: '0',
                text: 'Loading Data...'
            }],
            defaultOptionValue: "Loading Data...",
            isFetchingData: true
        });

        if (apiRequest === undefined) {

            this.props.apiRequest
                .then((data: any) => {
                    if (data.isSuccess) {
                        this.setState({
                            isFetchingData: false,
                            options: data.result,
                            defaultOptionValue: "Pilih Opsi..."
                        });
                    }
                });

        } else {

            apiRequest
                .then((data: any) => {
                    if (data.isSuccess) {
                        this.setState({
                            isFetchingData: false,
                            options: data.result,
                            defaultOptionValue: "Pilih Opsi..."
                        });
                    }
                });

        }
    };

    public render() {

        if (this.state.isFetchingData) {
            return (
                <Form.Dropdown
                    placeholder={this.state.defaultOptionValue}
                    fluid={true}
                    selection={true}
                    value={this.state.options[0].value}
                    options={this.state.options}
                    loading={true}
                />
            );
        }

        return (
            <Form.Dropdown
                name={this.props.id}
                id={this.props.id}
                placeholder={this.state.defaultOptionValue}
                fluid={this.props.fluid}
                search={true}
                selection={true}
                disabled={this.state.isFetchingData || this.props.readOnly}
                options={this.state.options}
                value={this.props.value}
                onChange={this.onChangeListener}
            />
        );
    }

    private onChangeListener = (e: any, data: any) => {
        const result = {
            target: {
                name: data.name,
                value: data.value
            }
        };

        this.props.onSelected(result);
    }

}


// WEBPACK FOOTER //
// ./src/component/form/SelectOption.tsx